import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Alpine from "alpinejs";

gsap.registerPlugin(ScrollTrigger);

/** Subtle zoom-out while the image scrolls into view, tied to the scroll position. */
Alpine.data("imageBlock", () => ({
  tween: null as gsap.core.Tween | null,

  init() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const img = this.$root.querySelector<HTMLElement>(".c-image-block__img");
    if (!img) return;

    this.tween = gsap.fromTo(
      img,
      { scale: 1.15 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: img,
          start: "top bottom", // image top enters the viewport
          end: "center center", // fully zoomed out once it's centred
          scrub: 0.8, // smoothing: the zoom trails the scroll a little
        },
      }
    );
  },

  destroy() {
    this.tween?.scrollTrigger?.kill();
    this.tween?.kill();
  },
}));
